/**
 * Upgrade Banner Configuration
 * =============================
 * 
 * This file controls the upgrade banner that promotes AI feature plans.
 * 
 * USAGE:
 * ------
 * The banner is automatically shown in the following pages:
 * - Dashboard
 * - AI Image Generator
 * - AI Video Generator
 * - AI Avatar Videos
 * - AI Video Creator (Multi-scene)
 * 
 * VISIBILITY RULES:
 * -----------------
 * The banner will only show when ALL of these conditions are met:
 * 1. SHOW_UPGRADE_BANNER is true (see environment variables below)
 * 2. User is a main user (company owner)
 * 3. Not on a whitelabel instance
 * 4. User doesn't have an active premium subscription (or is on free/trial plan)
 * 5. Banner hasn't been dismissed in the last BANNER_DISMISSAL_DURATION_DAYS
 * 
 * ENVIRONMENT VARIABLES:
 * ----------------------
 * Add to your .env file:
 * REACT_APP_SHOW_UPGRADE_BANNER=false    # To completely hide the banner
 * REACT_APP_SHOW_UPGRADE_BANNER=true     # To enable the banner (default)
 * 
 * CUSTOMIZATION:
 * --------------
 * - Edit UPGRADE_BANNER_CONFIG below to change the banner content
 * - Adjust BANNER_DISMISSAL_DURATION_DAYS to change how long dismissal lasts
 * - Modify enabledPages to control which pages show the banner
 */

// Environment variable to enable/disable the banner globally
// Set REACT_APP_SHOW_UPGRADE_BANNER=false in .env to completely hide the banner
export const SHOW_UPGRADE_BANNER = process.env.REACT_APP_SHOW_UPGRADE_BANNER !== 'false';

// LocalStorage key for tracking banner dismissal
export const UPGRADE_BANNER_DISMISSED_KEY = 'followr_upgrade_banner_dismissed';

// Banner expiration time (in days) - after dismissal, show again after this period
export const BANNER_DISMISSAL_DURATION_DAYS = 7;

// Banner configuration
export const UPGRADE_BANNER_CONFIG = {
    title: 'Check out our new AI plans! 🚀',
    description: 'Upgrade your plan to access enhanced AI image generation, video creation, and avatar videos capabilities.',
    ctaText: 'View Plans',
    dismissText: 'Maybe Later',
    // Pages where the banner should appear
    enabledPages: ['dashboard', 'ai-image', 'ai-video', 'ai-avatar-videos', 'ai-video-creator', 'avatars', 'ai-voices'],
};

